export enum SORT_BY {
  ASC = "A-Z",
  RANK = "Rank",
  LATEST_UPDATED = "Latest Updated",
}
